import TooltipM, { TooltipProps as TooltipPropsM } from '@mui/material/Tooltip';

import Box from '../Box/Box.jsx';
import Button, { ButtonProps } from '../Button/Button.jsx';
import Typography from '../Typography/Typography.jsx';

interface BtnProps extends ButtonProps {
  label?: string;
}

export type RichTooltipProps = Omit<TooltipPropsM, 'title'> & {
  title?: string;
  description?: string;
  primaryButtonProps?: BtnProps | null;
  secondaryButtonProps?: BtnProps | null;
};

const isUnset = (
  title: string | undefined | null,
  description: string | undefined | null,
) => {
  return (
    (title === undefined && description === undefined) ||
    (title === null && description === null)
  );
};

/**
 * @deprecated Use the new RichTooltip component from @mint-lib/tw-components/patterns instead.
 */
function RichTooltip({
  placement = 'top',
  primaryButtonProps,
  secondaryButtonProps,
  title,
  ...props
}: RichTooltipProps) {
  return (
    <TooltipM
      placement={placement}
      {...props}
      arrow={false}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: (theme) =>
              `${theme.palette.ui.primary} !important`,
            color: (theme) => `${theme.palette.text.primary} !important`,
            padding: '12px 16px !important',
            filter: 'none !important',
            boxShadow: `0px 4px 8px 0px rgba(0, 0, 0, 0.25) !important`,
            '&.MuiTooltip-tooltipPlacementTop': {
              marginBottom: '4px !important',
            },
          },
        },
      }}
      title={
        isUnset(title, props.description) ? undefined : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {title ? <Typography variant="h6">{title}</Typography> : null}
              {props.description ? (
                <Typography variant="bodyLong01">
                  {props.description}
                </Typography>
              ) : null}
            </Box>
            {primaryButtonProps || secondaryButtonProps ? (
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
                {!!primaryButtonProps && (
                  <Button {...primaryButtonProps} variant="plain">
                    {primaryButtonProps?.label
                      ? primaryButtonProps?.label
                      : 'Cancel'}
                  </Button>
                )}

                {!!secondaryButtonProps && (
                  <Button {...secondaryButtonProps} variant="plain">
                    {secondaryButtonProps?.label
                      ? secondaryButtonProps?.label
                      : 'Save'}
                  </Button>
                )}
              </Box>
            ) : null}
          </Box>
        )
      }
    >
      {props.children}
    </TooltipM>
  );
}

export default RichTooltip;
